import { render, staticRenderFns } from "./CameraPage.vue?vue&type=template&id=21740b65"
import script from "./CameraPage.vue?vue&type=script&lang=js"
export * from "./CameraPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports